import React from 'react'

import { CircleAlert } from 'lucide-react'
import { useShallow } from 'zustand/react/shallow'

import { Card, CardContent } from '@harvey-frontend/components/ui/card'
import { Switch } from '@harvey-frontend/components/ui/switch'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@harvey-frontend/components/ui/tooltip'

import { RequestMode } from '../../../utils/constants'
import { useRequestMode } from '../hooks/useRequestMode'
import useAppStore from '../stores/store'

const ReviewSuggestionsToggle: React.FC = () => {
  const mode = useRequestMode()
  const { reviewSuggestions, isFetching, setReviewSuggestions, queryError } =
    useAppStore(
      useShallow((s) => ({
        isFetching: s.isFetching,
        reviewSuggestions: s.reviewSuggestions,
        setReviewSuggestions: s.setReviewSuggestions,
        queryError: s.queryError,
      }))
    )

  const handleToggleChange = (checked: boolean) => {
    setReviewSuggestions(checked)
  }

  if (mode === RequestMode.INSERT) {
    return null
  }

  return (
    <Card className="flex items-center rounded-sm">
      <CardContent className="flex w-full items-center gap-2 border-0 p-2">
        <p className="flex-1 text-sm font-medium">Suggestions</p>
        {queryError && (
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex items-center gap-1 text-sm font-medium">
                <CircleAlert className="h-3 w-3 text-destructive" />
                Try again
              </div>
            </TooltipTrigger>
            <TooltipContent>{queryError.reason}</TooltipContent>
          </Tooltip>
        )}
        <Switch
          checked={reviewSuggestions}
          onCheckedChange={handleToggleChange}
          disabled={isFetching}
        />
      </CardContent>
    </Card>
  )
}

export default ReviewSuggestionsToggle
